export default {
  'meta': {
    'langName': 'ANGLAIS',
    'lang': 'English'
  },
  'title': 'PRODUCT RECALL BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'Hello,\n\n\nYou recently purchased a Tarmak B900 BOX NBA basketball hoop, and we thank you for your purchase.\n\nAs part of our ongoing commitment to product quality and safety, the DECATHLON Basketball team has identified a potential risk of the pole falling vertically if the height adjustment crank is removed and the product is then handled or used.\n\nWe kindly ask you to answer a few questions so we can provide you with the appropriate safety solution for your product.\n\nWe apologize for the inconvenience and thank you for your trust.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'First, could you please confirm your email address and country of residence:\r'
  },
  'fields': {
    'country': 'Country',
    'address': 'Mail adress',
    'email': 'Mail adress',
    'phonePrefix': 'Telephone number code',
    'phone': 'Phone number',
    'validations': {
      'phoneOrEmail': 'Please provide at least an email address or a phone number.',
      'email': 'Please enter a valid mail adress',
      'phone': 'Please enter a valid phone number'
    },
    'firstName': 'Surname',
    'lastName': 'First name',
    'deliveryAddress': 'Shipping address for the package',
    'additionalAddress': 'Additional address details',
    'city': 'City',
    'zip': 'ZIP Code / Postal Code',
    'choose': 'Select',
    'required': 'This field is required'
  },
  'ownerCheck': {
    'title': 'Do you still own one or more B900 BOX NBA basketball hoops?\r'
  },
  'yes': 'YES',
  'no': 'NO',
  'ownerChanged': {
    'title': 'Do you have the contact details of the current owner(s)?',
    'confirmation': 'Mr./Ms.,\n\nThank you for your participation in this quality initiative.\n\nWe apologize for the inconvenience and thank you for your trust.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Please indicate the number of basketball hoops you have, based on the type of crank installed',
    'descriptionRed': 'Basketball hoop with removable red crank',
    'descriptionBlack': 'Basketball hoop with fixed black crank',
    'quantity': 'Quantity',
    'notConcerned': 'Mr./Ms.,\n\nThank you for participating in this quality initiative.\n\nYou can rest assured that your Tarmak B900 BOX NBA basketball hoop is not affected by the recall process. It is safe to use.\n\nWe apologize for any inconvenience and thank you for your trust.\n\nDECATHLON',
    'concernedProductQuantity': 'Non conform product quantity :',
    'concernedProductLabel': 'Non conform product :',
    'confirmation': 'Thank you for completing this form. Your request has been successfully recorded.\n\nWe will send you the tracking number for your kit delivery as soon as possible (via FandiWeb for European countries / via X for non-European countries).\n\nWe wish you a great day.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Repair with your participation',
    'description': 'We have detected a risk of the pole falling vertically if the crank is removed and the product is handled or used on certain TARMAK B900 BOX NBA basketball hoops, ref. 4239136.\r\nBased on your response, your product appears to be affected by this risk.\r\n\r\nWe therefore ask you to stop using it immediately and offer to assist you in adapting the crank so that you can use your product safely.\r\nRest assured, this repair requires no special expertise—everything is clearly explained in the video and instruction manual below:\r',
    'videoLink': 'Video link',
    'docLink': 'Notice link',
    'callToAction': 'Click here to receive your free repair kit',
    'warranty': 'The entire process is covered by our 5-year warranty.'
  },
  'repairRequest': {
    'title': 'Please enter the following information so that your free kit can be sent to the address of your choice:'
  },
  'form': {
    'submit': 'Next'
  },
  'status': 'Translation validated by SPORT'
} as const
